import { Button } from "apps/visits/packages/ui/src/components";
import { useTranslation } from "react-i18next";
import { useResendCode } from "../../hooks/use-resend-code";
import type { ConfigName } from "../../types/config-name";

export const ResendCode = ({ configName }: { configName: ConfigName }) => {
  const { t } = useTranslation();
  const { handleSubmit, isLoading, isSuccess, isError } = useResendCode({ configName });

  const handleOnClick = () => {
    handleSubmit();
  };

  return (
    <>
      <div className="mt-8 flex items-center">
        {isSuccess ? (
          <p className="text-base text-grey-700">{t("VOUCHERS_DISTRIBUTION.CODE_VALIDATION_FORM.RESEND_SUCCESS")}</p>
        ) : (
          <>
            <p className="text-base text-grey-700">
              {t("VOUCHERS_DISTRIBUTION.CODE_VALIDATION_FORM.CODE_NOT_RECEIVED")}
            </p>
            <Button
              variant="link"
              color="primary"
              className="no-underline"
              onClick={handleOnClick}
              disabled={isLoading}
              type="button"
            >
              {t("VOUCHERS_DISTRIBUTION.CODE_VALIDATION_FORM.RESEND_CODE")}
            </Button>
          </>
        )}
      </div>
      {isError && <span className="mt-3 block text-error">{t("COMMONS.ERRORS.GENERAL_API_ERROR")}</span>}
    </>
  );
};
